import React from 'react'

export default function Footer() {
  return (
      <div className='bg-success-subtle' style={{textAlign:'center',fontWeight:'bold',position:'sticky',bottom:'0',width:'100%',paddingTop:'10px',paddingBottom:'10px'}}>© 2024 Nillum Hardware</div>
  )
}
